import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ProjectProjectActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Project/ProjectBrowser")
	}

	render() {
		return (
			<Activity 
				name="ProjectProject"
				RenderedComponent={this.RenderedComponent}
				context="ProjectProject"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ProjectProjectActivity)
